import { useWatch, type Control } from 'react-hook-form'

const isActive = (value: unknown): boolean => {
    if (Array.isArray(value)) return value.some(isActive)
    return (
        value !== undefined && value !== null && value !== '' && value !== false
    )
}

/**
 * How many of `names` hold a value — the count on a `FilterPopover` button
 * whose fields are custom components (`children`) rather than `items`.
 */
export function useActiveFilterCount(
    // Any form's control: only the listed field names are read.
    control: Control<any>,
    names: string[]
): number {
    const values = useWatch({ control, name: names as never }) as unknown
    return Array.isArray(values) ? values.filter(isActive).length : 0
}
